export const headerObjOne = {
    headTitle: "Events"
  };
  
  export const headerObjTwo = {
    headTitle: "About"
  };
  
  export const headerObjThree = {
    headTitle: "Discover."
  };
  
  export const headerObjFour = {
    headTitle: "Team"
  };

  export const headerObjFive = {
    headTitle: "EB 2020"
  };

  export const headerObjSix = {
    headTitle: "EB 2019"
  };

  export const headerObjSeven = {
    headTitle: "EB 2018"
  };

  export const headerObjEight = {
    headTitle: "WiOS EB"
  };

  export const headerObjNine = {
    headTitle: "Gallery"
  };

  export const headerObjTen = {
    headTitle: "Testimonials"
  };

  export const headerObjEleven = {
    headTitle: "EB Openings"
  };

  export const headerObjTwelve = {
    headTitle: "Contact Us"
  };

  export const headerObjThirteen = {
    headTitle: "Sponsorships"
  };

  export const headerObjFourteen = {
    headTitle: "EB Elections"
  };

  export const headerObjFifteen = {
    headTitle: "WiOS"
  };

  export const headerObjSixteen = {
    headTitle: "Projects"
  };

export const headerObjSeventeen = {
    headTitle: "EB 2021"
  };
export const headerObjEighteen = {
  headTitle: "EB 2022"
};
export const headerObjNineteen = {
  headTitle: "EB 2023"
};
